import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import css from './MapFetching.css'
import type { StatisticsProps } from './Statistics'
import { Statistics } from './Statistics'

type RightMenuProps = {
  statisticsProps?: StatisticsProps
  name: Nullable<string>
  onNameChange?: (name: Nullable<string>) => void
}

export const RightMenu: FC<RightMenuProps> = ({ statisticsProps, name, onNameChange }) => {
  const onNameChanged = (value: Nullable<string>) => onNameChange?.(value)

  return (
    <div className={css.menu}>
      <Text className={css.headerDescription} weight="semibold" size="s" view="primary">
        Результаты
      </Text>
      <TextField
        label="Название"
        placeholder="Введите название карты"
        type="text"
        size="xs"
        withClearButton={true}
        value={name}
        onChange={onNameChanged}
      />
      <Text className={css.marginForName} view="ghost" size="xs">
        Если пусто, название сгенерируется автоматически после выбора карты и маркера
      </Text>
      {!!statisticsProps && <Statistics {...statisticsProps} />}
    </div>
  )
}
